export default {
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },

  departments(state, departments) {
    return (state.departments = departments);
  },

  branches(state, branches) {
    return (state.branches = branches);
  },
  stationDepartments(state, value) {
    return (state.stationDepartments = value);
  },
  totalEmployees(state, total) {
    return (state.totalEmployees = total);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  filterValue(state, value) {
    return (state.filterValue = value);
  },
  employees(state, employees) {
    return (state.employees = employees);
  },
};
